/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { WizardStep, WizardStepProps } from '@squiz/sds';
import React from 'react';
import { SettingCreateProps } from '../../elements/SettingCreate/SettingCreate.props';
import { SettingCreateForm } from '../../forms/SettingCreateForm/SettingCreateForm';
import { SettingValueForm } from '../../forms/SettingValueForm/SettingValueForm';

/**
 * The steps required to support the Setting Creation process.
 */
export const getSettingCreationSteps = (customProps: SettingCreateProps): Array<WizardStep> => {
  const createSetting = {
    renderStep: (props: WizardStepProps): JSX.Element => {
      const formProps = { ...props };
      formProps.customProps = customProps;

      return <SettingCreateForm {...formProps} />;
    },
  };

  const addSettingValue = {
    renderStep: (props: WizardStepProps): JSX.Element => <SettingValueForm {...props} />,
  };

  return [createSetting, addSettingValue];
};
